import { render, staticRenderFns } from "./UgcLibrary.vue?vue&type=template&id=652a0fc4&scoped=true&"
import script from "./UgcLibrary.vue?vue&type=script&lang=js&"
export * from "./UgcLibrary.vue?vue&type=script&lang=js&"
import style0 from "./UgcLibrary.vue?vue&type=style&index=0&id=652a0fc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652a0fc4",
  null
  
)

export default component.exports